<template>
    <div>
        <div class="card mb-3" id="income">
            <div class="card-header headline income">
                <h2 class="text-white d-inline">درآمد</h2>
                <button class="btn btn-secondary float-left" data-toggle="modal" data-target="#income-modal" @click="onModalButtonClicked">افزودن درآمد</button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mb-3">
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                    <div class="col-lg-12 mt-5" v-if="incomes.length < 1">
                        <h3 class="text-center no-item-alert">درآمد ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in incomes">
                        <div class="card shadow pt-2 pb-2" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12">
                                    <h5 class="text-center">{{item.outSourceName}}</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="incomes.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getincomes">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loading">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && incomes.length < dataCount" class="col-lg-12 text-center mb-3" @click="getincomes">
                        <button class="btn btn-success">نمایش موارد بیشتر</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="income-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن درآمد</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش درآمد</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">عنوان درآمد</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="income.outSourceName">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger mr-2" v-if="params.mode === 'edit'" @click="deleteItem()">حذف</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'income',
        components: {VsSelect},
        data() {
            return {
                incomes: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    // parrentId: 7,
                    types: 7
                },
                income: {
                    title: "",
                    // parrentId: 7,
                    type: 7
                },
                params: {
                    mode: 'create'
                },
                searchString: "",
                dataCount: 0,

                autoload: false,
                isSending: false,
            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                this.incomes = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.incomes.length < this.dataCount) {
                        $("#loading").show();
                        this.getincomes();
                    }
                });
            }
        },
        methods: {
            getincomes() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                    this.incomes.push.apply(this.incomes, response.data.data);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                    this.incomes = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
            },
            onCardClicked(index) {
                this.params.mode = 'edit';
                this.income = JSON.parse(JSON.stringify(this.incomes[index]));
                $("#income-modal").modal("show");
            },
            onModalButtonClicked() {
                this.params.mode = 'create';
                this.income = {
                    title: "",
                    // parrentId: 7,
                    type: 7
                };
                console.log(this.income)
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.income);
                } else {
                    this.onUpdate(this.income);
                }
            },
            onCreate(income) {
                if (!this.isSending) {
                    this.isSending = true;
                    income.rowVersion = this.generateUuid();
                    console.log(income)
                    new BaseService('outsource').create(income).then(response => {
                        this.$noty.success("درآمد با موفقیت افزوده شد.");
                        $("#income-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                            this.incomes = response.data.data;
                            $("#loading").hide();
                            Utils.resetObject(this.income);
                            // this.income.parrentId = 7;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            onUpdate(income) {
                new BaseService('outsource').update(income).then(response => {
                    this.$noty.success("درآمد با موفقیت ویرایش شد.");
                    $("#income-modal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                        this.incomes = response.data.data;
                        $("#loading").hide();
                        Utils.resetObject(this.income);
                        // this.income.parrentId = 7;
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
            },
            deleteItem() {
                if (confirm("آیا از حذف اطمینان دارید؟")) {
                    if (!this.isSending) {
                        this.isSending = true;
                        new BaseService('outsource').delete(this.income.id).then(response => {
                            this.$noty.success("با موفقیت حذف شد.");
                            $("#income-modal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('outsource', '/getList').getList(this.queryParams).then(response => {
                                this.incomes = response.data.data;
                                $("#loading").hide();
                                Utils.resetObject(this.income);
                                // this.income.parrentId = 7;
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            this.$noty.error(error.data.message);
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#income-modal").hasClass("show")) {
                $("#income-modal").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>